import { endpoints } from '@rossum/api-client';
import {
  RuleExecutionLog,
  RulesExecutionLogsQuery,
} from '@rossum/api-client/rulesExecutionLogs';
import { api } from '../../../lib/apiClient';
import { useNewItemsCheck } from '../../../utils/hooks/useNewItemsCheck';

export const QUERY_KEY_NEW_RULES_EXECUTION_LOGS_CHECK =
  'rules-execution-logs-new-check';

type UseNewRulesExecutionLogsCheckParams = {
  latestKnownId: string | undefined;
  logsQuery: Omit<RulesExecutionLogsQuery, 'page' | 'pageSize'>;
  enabled: boolean;
  onNewLogs: () => void;
};

const getLogId = (log: RuleExecutionLog) =>
  `${log.requestId}-${log.ruleId}-${log.createdAt}`;

export const useNewRulesExecutionLogsCheck = ({
  latestKnownId,
  logsQuery,
  enabled,
  onNewLogs,
}: UseNewRulesExecutionLogsCheckParams) => {
  return useNewItemsCheck<
    RuleExecutionLog,
    Omit<RulesExecutionLogsQuery, 'page' | 'pageSize'>
  >({
    queryKey: QUERY_KEY_NEW_RULES_EXECUTION_LOGS_CHECK,
    queryFn: query =>
      api.request(
        endpoints.rulesExecutionLogs.list({
          ...query,
          pageSize: 1,
        })
      ),
    getId: getLogId,
    query: logsQuery,
    latestKnownId,
    enabled,
    onNewItems: onNewLogs,
  });
};
